function closeAccordion(button) {
  const accordion = button.parentElement;
  accordion.classList.remove("accordion--open");
  button.setAttribute("aria-expanded", "false");
}

function openAccordion(button) {
  const accordion = button.parentElement;
  accordion.classList.add("accordion--open");
  button.setAttribute("aria-expanded", "true");
}

function closeAllAccordions(buttons, currentbutton) {
  buttons.forEach((buttons) => {
    if (buttons !== currentbutton) {
      closeAccordion(buttons);
    }
  });
}

function accordion() {
  const buttons = document.querySelectorAll(".accordion__trigger");
  if (!buttons.length) return;

  buttons.forEach((button) => {
    button.setAttribute("aria-expanded", "false");

    button.addEventListener("click", () => {
      const isExpanded = button.getAttribute("aria-expanded") === "true";

      closeAllAccordions(buttons, button);

      if (!isExpanded) {
        openAccordion(button);
      } else {
        closeAccordion(button);
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", accordion);
